module.exports = "/templates/bds/public/font/80329a35cee0268dc6cf640911ad9bab.ttf";